import { useAuthState } from '../hooks/useAuthState'
import { useMyConvexOrganizationId } from '../hooks/useMyConvexOrganizationId'
import { useOrganizationData } from '../hooks'
import { UserProfile } from './user-profile'

interface ConnectedUserProfileProps {
  manager?: {
    id: string
    name: string
  } | null
  position?: {
    title: string
    role: string
    level: string
  } | null
}

export function ConnectedUserProfile({
  manager,
  position,
}: ConnectedUserProfileProps) {
  const { user } = useAuthState()
  const convexOrgId = useMyConvexOrganizationId()
  const organizations = useOrganizationData()

  if (!user) {
    return null
  }

  // Find the membership record whose externalId matches the current Convex org ID
  const currentMembershipId = organizations.find(
    (o) => o.externalId === convexOrgId,
  )?.id

  return (
    <UserProfile
      user={user}
      organizations={organizations}
      currentOrganizationId={currentMembershipId}
      manager={manager}
      position={position}
    />
  )
}
